import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CountUpModule } from 'ngx-countup';
import { PublicServiceService } from 'src/app/public-service.service';

@Component({
  selector: 'app-vision-mission',
  standalone: true,
  imports: [CountUpModule, RouterLink, CommonModule],
  templateUrl: './vision-mission.component.html',
  styleUrl: './vision-mission.component.scss'
})
export class VisionMissionComponent {

  visions: any

  constructor(private publicService: PublicServiceService, 
  ) {

  }

  ngOnInit(): void {

    this.getData()
  }

	
  getData() {
    this.publicService.getRecordHome(this.publicService.VISION_URL).subscribe({
      next: (res) => {
        this.visions = res

      },
      error: (error) => {
        console.error("here goes the Unexpected error:", error);
      }
    })
  }
}
